module.exports = __webpack_public_path__ + "img/jylnicon5.8d3849e9.jpg";